'use strict';

module.exports = function(newDirection) {
	this.context.clearRect(0, 0, this.x1, this.y1);
	this.direction = newDirection;
	this.validateInput('direction');
	if (this.isPaused) this.refreshColors();
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/granim/lib/changeDirection.js
// module id = 46
// module chunks = 0